import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './components/Decorations.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Footer from './components/Footer';
import ServiceDetail from './components/ServiceDetail';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import WorkPage from './components/WorkPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookieConsent from './components/CookieConsent';
import Disclaimer from './components/Disclaimer';
import ServicesPage from './components/ServicesPage';
import SolutionsPage from './components/SolutionsPage';

import AdSenseManager from './components/AdSenseManager';
import NotFound from './components/NotFound';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';



function App() {
  return (
    <Router>
      <div className="App">
        <AdSenseManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/work" element={<WorkPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/service/:id" element={<ServiceDetail />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/disclaimer" element={<Disclaimer />} />

            <Route path="*" element={<NotFound />} />
          </Routes>


        </main>
        <Footer />
        <CookieConsent />
        <ScrollToTop />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
